import invoices from '../api/invoices'
import { DateTime } from 'luxon';
import { numberWithCommas } from '../helpers/numberWithCommas';

export default {
    state: {
        advInvoices: [],
    },
    namespaced: true,
    mutations: {
        async saveAdvInvoices(state, advInvoices) {
            state.advInvoices = advInvoices.map(value => {
                const dateStart = new Date(value.start).getDate();
                const dateEnd = new Date(value.end).getDate();
                const month = new Date(value.start).getMonth() + 1;
                const year = new Date(value.start).getFullYear();
                let monthName = DateTime.local(year, month, dateStart).monthLong;
                monthName = monthName.charAt(0).toUpperCase() + monthName.slice(1);

                value.cost = numberWithCommas(value.cost);
                value.modifications = numberWithCommas(value.modifications);
                value.revenue = numberWithCommas(value.revenue);
                value.revenue_eur = numberWithCommas(value.revenue_eur);
                value.commissions = numberWithCommas(value.commissions);
                value.commissions_eur = numberWithCommas(value.commissions_eur);
                value.margin = value.margin * 100;

                value.corps.sort((a, b) => a.corp_name.localeCompare(b.corp_name))

                return {
                    name: '-',
                    periodDuration: `${monthName} ${dateStart} - ${dateEnd}, ${year}`,
                    count: `${value.corps.length} invoices`,
                    ...value
                }
            });
        },
    },
    actions: {
        async getAdvInvoices({dispatch, commit}, data) {
            commit('saveAdvInvoices', await invoices.getAdvInvoices(data));
        },
    },
    getters: {
        advInvoices: state => state.advInvoices,
    },

}
